import { useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function GalleryModal({ images, currentIndex, onClose, onPrev, onNext }) {
  const { t, language } = useLanguage();
  const currentImage = images[currentIndex];

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft') onPrev();
    if (e.key === 'ArrowRight') onNext();
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-2 text-white/70 hover:text-white transition-colors"
        aria-label={t('gallery.lightbox.close')}
      >
        <X className="w-8 h-8" />
      </button>

      {/* Previous button */}
      <button
        onClick={onPrev}
        className="absolute left-4 z-10 p-2 text-white/70 hover:text-white transition-colors"
        aria-label={t('gallery.lightbox.prev')}
      >
        <ChevronLeft className="w-10 h-10" />
      </button>

      {/* Image */}
      <div className="max-w-5xl max-h-[80vh] mx-4">
        <img
          src={currentImage.src}
          alt={currentImage.alt[language]}
          className="max-w-full max-h-[80vh] object-contain"
        />
        <p className="text-center text-white mt-4">
          {currentImage.alt[language]}
          <span className="text-white/50 ml-2">
            ({currentIndex + 1} / {images.length})
          </span>
        </p>
      </div>

      {/* Next button */}
      <button
        onClick={onNext}
        className="absolute right-4 z-10 p-2 text-white/70 hover:text-white transition-colors"
        aria-label={t('gallery.lightbox.next')}
      >
        <ChevronRight className="w-10 h-10" />
      </button>
    </div>
  );
}
